import React, { useState, useEffect } from 'react';
import withRouter from './../../../Components/Common/withRouter'; //src/Components/Common/withRouter.js
import {
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody,
    Collapse
} from "reactstrap";

//redux
import {
    changeLayout,
    changeSidebarTheme,
    changeLayoutMode,
    changeLayoutWidth,
    changeLayoutPosition,
    changeTopbarTheme,
    changeLeftsidebarSizeType,
    changeLeftsidebarViewType,
    changeSidebarImageType,
    changePreLoader,
    changeSidebarVisibility
    // resetValue
} from "../../../slices/thunks";

import { useSelector, useDispatch } from "react-redux";

//import Constant
import {
    layoutTypes,
    leftSidebarTypes,
    layoutModeTypes,
    layoutWidthTypes,
    layoutPositionTypes,
    topbarThemeTypes,
    leftsidbarSizeTypes,
    leftSidebarViewTypes,
    leftSidebarImageTypes,
    preloaderTypes,
    sidebarVisibilitytypes
} from "../../../Components/constants/layout";

//SimpleBar
import SimpleBar from "simplebar-react";
import classnames from "classnames";
import { useLocation } from "react-router-dom";
//import Images
import img01 from "../../../assets/images/sidebar/img-1.jpg";
import img02 from "../../../assets/images/sidebar/img-2.jpg";
import img03 from "../../../assets/images/sidebar/img-3.jpg";
import img04 from "../../../assets/images/sidebar/img-4.jpg";
import { createSelector } from 'reselect';
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";
import LoadingScreen from "../util/LoadingScreen";
const ConfigLayoutPage = ({ handleSubmitImage }) => {

    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const [loadingPage, setLoadingPage] = useState(false);
    function tog_show() {
        setShow(!show);
        dispatch(changeSidebarTheme("gradient"));
    }

    useEffect(() => {
        if (show && document.getElementById("sidebar-color-dark") && document.getElementById("sidebar-color-light")) {
            document.getElementById("sidebar-color-dark").checked = false;
            document.getElementById("sidebar-color-light").checked = false;
        }
    });
    const selectLayoutState = (state) => state.Layout;
    const selectLayoutProperties = createSelector(
        selectLayoutState,
        (layout) => ({
            layoutType: layout.layoutType,
            leftSidebarType: layout.leftSidebarType,
            layoutModeType: layout.layoutModeType,
            layoutWidthType: layout.layoutWidthType,
            layoutPositionType: layout.layoutPositionType,
            topbarThemeType: layout.topbarThemeType,
            leftsidbarSizeType: layout.leftsidbarSizeType,
            leftSidebarViewType: layout.leftSidebarViewType,
            leftSidebarImageType: layout.leftSidebarImageType,
            preloader: layout.preloader,
            sidebarVisibilitytype: layout.sidebarVisibilitytype,
        })
    );
    // Inside your component
    const {
        layoutType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        leftsidbarSizeType,
        leftSidebarViewType,
        leftSidebarImageType,
        preloader,
        sidebarVisibilitytype
    } = useSelector(selectLayoutProperties);

    // open offcanvas
    const [open, setOpen] = useState(true);
    const toggleLeftCanvas = () => {
        setOpen(!open);
    };

    window.onscroll = function () {
        scrollFunction();
    };

    const scrollFunction = () => {
        const element = document.getElementById("back-to-top");
        if (element) {
            if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
                element.style.display = "block";
            } else {
                element.style.display = "none";
            }
        }
    };

    const toTop = () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    };

    const location = useLocation();
    const pathName = location.pathname;

    useEffect(() => {
        const preloader = document.getElementById("preloader");
        if (preloader) {
            document.getElementById("preloader").style.opacity = "1";
            document.getElementById("preloader").style.visibility = "visible";
            setTimeout(function () {
                document.getElementById("preloader").style.opacity = "0";
                document.getElementById("preloader").style.visibility = "hidden";
            }, 1000);
        }
    }, [preloader, pathName]);

    const saveConfig = async () => {
        try {
            const payload = {
                layoutType,
                leftSidebarType,
                layoutModeType,
                layoutWidthType,
                layoutPositionType,
                topbarThemeType,
                leftsidbarSizeType,
                leftSidebarViewType,
                leftSidebarImageType,
                preloader,
                sidebarVisibilitytype
            };

            localStorage.setItem('layout', JSON.stringify(payload));
            ApiService.send('post', process.env.REACT_APP_URL_API + 'custom-domain/config/layout-save', payload, true).then((response) => {
                setLoadingPage(false); // Desativa o carregamento

                Swal.fire({
                    icon: 'success',
                    title: 'Sucesso!',
                    text: 'Configurações salvas com sucesso!',
                    timer: 2000,
                    showConfirmButton: false
                });
            }).catch(() => setLoadingPage(false));



        } catch (error) {
            ApiService.handleApiError(error);
        }
    };

    return (
        <div id="config_layout_page_tab" className="tab-pane fade">
            <div className="card">
                {loadingPage && <LoadingScreen/>}
                <div className="p-4">
                    <h6 className="mb-0 fw-semibold text-uppercase">Disposição</h6>
                    <p className="text-muted">Escolha seu layout</p>

                    <div className="row gy-3">
                        <div className="col-4">
                            <div className="form-check card-radio">
                                <input
                                    id="customizer-layout01"
                                    name="data-layout"
                                    type="radio"
                                    value={layoutTypes.VERTICAL}
                                    checked={layoutType === layoutTypes.VERTICAL}
                                    onChange={e => {
                                        if (e.target.checked) {
                                            dispatch(changeLayout(e.target.value));
                                        }
                                    }}
                                    className="form-check-input"
                                />
                                <label className="form-check-label p-0 avatar-md w-100" htmlFor="customizer-layout01">
                                                <span className="d-flex gap-1 h-100">
                                                    <span className="flex-shrink-0">
                                                        <span className="bg-light d-flex h-100 flex-column gap-1 p-1">
                                                            <span
                                                                className="d-block p-1 px-2 bg-primary-subtle rounded mb-2"></span>
                                                            <span
                                                                className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                            <span
                                                                className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                            <span
                                                                className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                        </span>
                                                    </span>
                                                    <span className="flex-grow-1">
                                                        <span className="d-flex h-100 flex-column">
                                                            <span className="bg-light d-block p-1"></span>
                                                            <span className="bg-light d-block p-1 mt-auto"></span>
                                                        </span>
                                                    </span>
                                                </span>
                                </label>
                            </div>
                            <h5 className="fs-13 text-center mt-2">Vertical</h5>
                        </div>
                        <div className="col-4">
                            <div className="form-check card-radio">
                                <input
                                    id="customizer-layout02"
                                    name="data-layout"
                                    type="radio"
                                    value={layoutTypes.HORIZONTAL}
                                    checked={layoutType === layoutTypes.HORIZONTAL}
                                    onChange={e => {
                                        if (e.target.checked) {
                                            dispatch(changeLayout(e.target.value));
                                        }
                                    }}
                                    className="form-check-input"/>
                                <label className="form-check-label p-0 avatar-md w-100" htmlFor="customizer-layout02">
                                                <span className="d-flex h-100 flex-column gap-1">
                                                    <span className="bg-light d-flex p-1 gap-1 align-items-center">
                                                        <span
                                                            className="d-block p-1 bg-primary-subtle rounded me-1"></span>
                                                        <span
                                                            className="d-block p-1 pb-0 px-2 bg-primary-subtle ms-auto"></span>
                                                        <span
                                                            className="d-block p-1 pb-0 px-2 bg-primary-subtle"></span>
                                                    </span>
                                                    <span className="bg-light d-block p-1"></span>
                                                    <span className="bg-light d-block p-1 mt-auto"></span>
                                                </span>
                                </label>
                            </div>
                            <h5 className="fs-13 text-center mt-2">Horizontal</h5>
                        </div>
                        <div className="col-4">
                            <div className="form-check card-radio">
                                <input
                                    id="customizer-layout03"
                                    name="data-layout"
                                    type="radio"
                                    value={layoutTypes.TWOCOLUMN}
                                    checked={layoutType === layoutTypes.TWOCOLUMN}
                                    onChange={e => {
                                        if (e.target.checked) {
                                            dispatch(changeLayout(e.target.value));
                                        }
                                    }}
                                    className="form-check-input"/>
                                <label className="form-check-label p-0 avatar-md w-100" htmlFor="customizer-layout03">
                                                <span className="d-flex gap-1 h-100">
                                                    <span className="flex-shrink-0">
                                                        <span className="bg-light d-flex h-100 flex-column gap-1">
                                                            <span className="d-block p-1 bg-primary-subtle mb-2"></span>
                                                            <span className="d-block p-1 pb-0 bg-primary-subtle"></span>
                                                            <span className="d-block p-1 pb-0 bg-primary-subtle"></span>
                                                            <span className="d-block p-1 pb-0 bg-primary-subtle"></span>
                                                        </span>
                                                    </span>
                                                    <span className="flex-shrink-0">
                                                        <span className="bg-light d-flex h-100 flex-column gap-1 p-1">
                                                            <span
                                                                className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                            <span
                                                                className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                            <span
                                                                className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                            <span
                                                                className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                        </span>
                                                    </span>
                                                    <span className="flex-grow-1">
                                                        <span className="d-flex h-100 flex-column">
                                                            <span className="bg-light d-block p-1"></span>
                                                            <span className="bg-light d-block p-1 mt-auto"></span>
                                                        </span>
                                                    </span>
                                                </span>
                                </label>
                            </div>
                            <h5 className="fs-13 text-center mt-2">Duas colunas</h5>
                        </div>
                        <div className="col-4">
                            <div className="form-check card-radio">
                                <input id="customizer-layout04" name="data-layout" type="radio"
                                       className="form-check-input"
                                       value={layoutTypes.SEMIBOX}
                                       checked={layoutType === layoutTypes.SEMIBOX}
                                       onChange={e => {
                                           if (e.target.checked) {
                                               dispatch(changeLayout(e.target.value));
                                           }
                                       }}
                                />
                                <label className="form-check-label p-0 avatar-md w-100" htmlFor="customizer-layout04">
                                                <span className="d-flex gap-1 h-100">
                                                    <span className="flex-shrink-0 p-1">
                                                        <span className="bg-light d-flex h-100 flex-column gap-1 p-1">
                                                            <span
                                                                className="d-block p-1 px-2 bg-primary-subtle rounded mb-2"></span>
                                                            <span
                                                                className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                            <span
                                                                className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                            <span
                                                                className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                        </span>
                                                    </span>
                                                    <span className="flex-grow-1">
                                                        <span className="d-flex h-100 flex-column pt-1 pe-2">
                                                            <span className="bg-light d-block p-1"></span>
                                                            <span className="bg-light d-block p-1 mt-auto"></span>
                                                        </span>
                                                    </span>
                                                </span>
                                </label>
                            </div>
                            <h5 className="fs-13 text-center mt-2">Semi Caixa</h5>
                        </div>
                    </div>

                    <h6 className="mt-4 mb-0 fw-semibold text-uppercase">Esquema de cores</h6>
                    <p className="text-muted">Choose Light or Dark Scheme.</p>

                    <div className="colorscheme-cardradio">
                        <div className="row">
                            <div className="col-4">
                                <div className="form-check card-radio">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="data-bs-theme"
                                        id="layout-mode-light"
                                        value={layoutModeTypes.LIGHTMODE}
                                        checked={layoutModeType === layoutModeTypes.LIGHTMODE}
                                        onChange={e => {
                                            if (e.target.checked) {
                                                dispatch(changeLayoutMode(e.target.value));
                                            }
                                        }}
                                    />
                                    <label className="form-check-label p-0 avatar-md w-100" htmlFor="layout-mode-light">
                                                    <span className="d-flex gap-1 h-100">
                                                        <span className="flex-shrink-0">
                                                            <span
                                                                className="bg-light d-flex h-100 flex-column gap-1 p-1">
                                                                <span
                                                                    className="d-block p-1 px-2 bg-primary-subtle rounded mb-2"></span>
                                                                <span
                                                                    className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                                <span
                                                                    className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                                <span
                                                                    className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                            </span>
                                                        </span>
                                                        <span className="flex-grow-1">
                                                            <span className="d-flex h-100 flex-column">
                                                                <span className="bg-light d-block p-1"></span>
                                                                <span className="bg-light d-block p-1 mt-auto"></span>
                                                            </span>
                                                        </span>
                                                    </span>
                                    </label>
                                </div>
                                <h5 className="fs-13 text-center mt-2">Luz</h5>
                            </div>

                            <div className="col-4">
                                <div className="form-check card-radio dark">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="data-bs-theme"
                                        id="layout-mode-dark"
                                        value={layoutModeTypes.DARKMODE}
                                        checked={layoutModeType === layoutModeTypes.DARKMODE}
                                        onChange={e => {
                                            if (e.target.checked) {
                                                dispatch(changeLayoutMode(e.target.value));
                                            }
                                        }}
                                    />
                                    <label className="form-check-label p-0 avatar-md w-100 bg-dark"
                                           htmlFor="layout-mode-dark">
                                                    <span className="d-flex gap-1 h-100">
                                                        <span className="flex-shrink-0">
                                                            <span
                                                                className="bg-white bg-opacity-10 d-flex h-100 flex-column gap-1 p-1">
                                                                <span
                                                                    className="d-block p-1 px-2 bg-white bg-opacity-10 rounded mb-2"></span>
                                                                <span
                                                                    className="d-block p-1 px-2 pb-0 bg-white bg-opacity-10"></span>
                                                                <span
                                                                    className="d-block p-1 px-2 pb-0 bg-white bg-opacity-10"></span>
                                                                <span
                                                                    className="d-block p-1 px-2 pb-0 bg-white bg-opacity-10"></span>
                                                            </span>
                                                        </span>
                                                        <span className="flex-grow-1">
                                                            <span className="d-flex h-100 flex-column">
                                                                <span
                                                                    className="bg-white bg-opacity-10 d-block p-1"></span>
                                                                <span
                                                                    className="bg-white bg-opacity-10 d-block p-1 mt-auto"></span>
                                                            </span>
                                                        </span>
                                                    </span>
                                    </label>
                                </div>
                                <h5 className="fs-13 text-center mt-2">Escura</h5>
                            </div>
                        </div>
                    </div>
                    {layoutType === layoutTypes.SEMIBOX && <div id="sidebar-visibility">
                        <h6 className="mt-4 mb-0 fw-semibold text-uppercase">Sidebar Visibility</h6>
                        <p className="text-muted">Choose show or Hidden sidebar.</p>

                        <div className="row">
                            <div className="col-4">
                                <div className="form-check card-radio">
                                    <input className="form-check-input" type="radio" name="data-sidebar-visibility"
                                           id="sidebar-visibility-show"
                                           value={sidebarVisibilitytypes.SHOW}
                                           checked={sidebarVisibilitytype === sidebarVisibilitytypes.SHOW}
                                           onChange={e => {
                                               if (e.target.checked) {
                                                   dispatch(changeSidebarVisibility(e.target.value));
                                               }
                                           }}/>
                                    <label className="form-check-label p-0 avatar-md w-100"
                                           htmlFor="sidebar-visibility-show">
                                                    <span className="d-flex gap-1 h-100">
                                                        <span className="flex-shrink-0 p-1">
                                                            <span
                                                                className="bg-light d-flex h-100 flex-column gap-1 p-1">
                                                                <span
                                                                    className="d-block p-1 px-2 bg-primary-subtle rounded mb-2"></span>
                                                                <span
                                                                    className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                                <span
                                                                    className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                                <span
                                                                    className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                            </span>
                                                        </span>
                                                        <span className="flex-grow-1">
                                                            <span className="d-flex h-100 flex-column pt-1 pe-2">
                                                                <span className="bg-light d-block p-1"></span>
                                                                <span className="bg-light d-block p-1 mt-auto"></span>
                                                            </span>
                                                        </span>
                                                    </span>
                                    </label>
                                </div>
                                <h5 className="fs-13 text-center mt-2">Mostrar</h5>
                            </div>
                            <div className="col-4">
                                <div className="form-check card-radio">
                                    <input className="form-check-input" type="radio" name="data-sidebar-visibility"
                                           id="sidebar-visibility-hidden"
                                           value={sidebarVisibilitytypes.HIDDEN}
                                           checked={sidebarVisibilitytype === sidebarVisibilitytypes.HIDDEN}
                                           onChange={e => {
                                               if (e.target.checked) {
                                                   dispatch(changeSidebarVisibility(e.target.value));
                                               }
                                           }}
                                    />
                                    <label className="form-check-label p-0 avatar-md w-100 px-2"
                                           htmlFor="sidebar-visibility-hidden">
                                                    <span className="d-flex gap-1 h-100">
                                                        <span className="flex-grow-1">
                                                            <span className="d-flex h-100 flex-column pt-1 px-2">
                                                                <span className="bg-light d-block p-1"></span>
                                                                <span className="bg-light d-block p-1 mt-auto"></span>
                                                            </span>
                                                        </span>
                                                    </span>
                                    </label>
                                </div>
                                <h5 className="fs-13 text-center mt-2">Escondido</h5>
                            </div>
                        </div>
                    </div>}
                    {layoutType !== layoutTypes.TWOCOLUMN && (
                        <React.Fragment>
                            {(layoutType === layoutTypes.VERTICAL || layoutType === layoutTypes.HORIZONTAL) && (
                                <div id="layout-width">
                                    <h6 className="mt-4 mb-0 fw-semibold text-uppercase">Layout Width</h6>
                                    <p className="text-muted">Choose Fluid or Boxed layout.</p>

                                    <div className="row">
                                        <div className="col-4">
                                            <div className="form-check card-radio">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="data-layout-width"
                                                    id="layout-width-fluid"
                                                    value={layoutWidthTypes.FLUID}
                                                    checked={layoutWidthType === layoutWidthTypes.FLUID}
                                                    onChange={e => {
                                                        if (e.target.checked) {
                                                            dispatch(changeLayoutWidth(e.target.value));
                                                            dispatch(changeLeftsidebarSizeType("lg"));
                                                        }
                                                    }}
                                                />
                                                <label className="form-check-label p-0 avatar-md w-100"
                                                       htmlFor="layout-width-fluid">
                                                            <span className="d-flex gap-1 h-100">
                                                                <span className="flex-shrink-0">
                                                                    <span
                                                                        className="bg-light d-flex h-100 flex-column gap-1 p-1">
                                                                        <span
                                                                            className="d-block p-1 px-2 bg-primary-subtle rounded mb-2"></span>
                                                                        <span
                                                                            className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                                        <span
                                                                            className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                                        <span
                                                                            className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                                    </span>
                                                                </span>
                                                                <span className="flex-grow-1">
                                                                    <span className="d-flex h-100 flex-column">
                                                                        <span className="bg-light d-block p-1"></span>
                                                                        <span
                                                                            className="bg-light d-block p-1 mt-auto"></span>
                                                                    </span>
                                                                </span>
                                                            </span>
                                                </label>
                                            </div>
                                            <h5 className="fs-13 text-center mt-2">Fluido</h5>
                                        </div>
                                        <div className="col-4">
                                            <div className="form-check card-radio">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="data-layout-width"
                                                    id="layout-width-boxed"
                                                    value={layoutWidthTypes.BOXED}
                                                    checked={layoutWidthType === layoutWidthTypes.BOXED}
                                                    onChange={e => {
                                                        if (e.target.checked) {
                                                            dispatch(changeLayoutWidth(e.target.value));
                                                            dispatch(changeLeftsidebarSizeType("sm-hover"));
                                                        }
                                                    }}
                                                />
                                                <label className="form-check-label p-0 avatar-md w-100 px-2"
                                                       htmlFor="layout-width-boxed">
                                                            <span
                                                                className="d-flex gap-1 h-100 border-start border-end">
                                                                <span className="flex-shrink-0">
                                                                    <span
                                                                        className="bg-light d-flex h-100 flex-column gap-1 p-1">
                                                                        <span
                                                                            className="d-block p-1 px-2 bg-primary-subtle rounded mb-2"></span>
                                                                        <span
                                                                            className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                                        <span
                                                                            className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                                        <span
                                                                            className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                                    </span>
                                                                </span>
                                                                <span className="flex-grow-1">
                                                                    <span className="d-flex h-100 flex-column">
                                                                        <span className="bg-light d-block p-1"></span>
                                                                        <span
                                                                            className="bg-light d-block p-1 mt-auto"></span>
                                                                    </span>
                                                                </span>
                                                            </span>
                                                </label>
                                            </div>
                                            <h5 className="fs-13 text-center mt-2">Encaixotado</h5>
                                        </div>
                                    </div>
                                </div>)}

                            <div id="layout-position">
                                <h6 className="mt-4 mb-0 fw-semibold text-uppercase">Posição do layout</h6>
                                <p className="text-muted">Escolha a posição de layout fixa ou rolável.</p>

                                <div className="btn-group radio" role="group">
                                    <input
                                        type="radio"
                                        className="btn-check"
                                        name="data-layout-position"
                                        id="layout-position-fixed"
                                        value={layoutPositionTypes.FIXED}
                                        checked={layoutPositionType === layoutPositionTypes.FIXED}
                                        onChange={e => {
                                            if (e.target.checked) {
                                                dispatch(changeLayoutPosition(e.target.value));
                                            }
                                        }}
                                    />
                                    <label className="btn btn-light w-sm" htmlFor="layout-position-fixed">Fixo</label>

                                    <input
                                        type="radio"
                                        className="btn-check"
                                        name="data-layout-position"
                                        id="layout-position-scrollable"
                                        value={layoutPositionTypes.SCROLLABLE}
                                        checked={layoutPositionType === layoutPositionTypes.SCROLLABLE}
                                        onChange={e => {
                                            if (e.target.checked) {
                                                dispatch(changeLayoutPosition(e.target.value));
                                            }
                                        }}
                                    />
                                    <label className="btn btn-light w-sm ms-0"
                                           htmlFor="layout-position-scrollable">Scrollable</label>
                                </div>
                            </div>
                        </React.Fragment>
                    )}

                    <h6 className="mt-4 mb-0 fw-semibold text-uppercase">Cor da barra superior</h6>
                    <p className="text-muted">Escolha a cor clara ou escura da barra superior.</p>

                    <div className="row">
                        <div className="col-4">
                            <div className="form-check card-radio">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="data-topbar"
                                    id="topbar-color-light"
                                    value={topbarThemeTypes.LIGHT}
                                    checked={topbarThemeType === topbarThemeTypes.LIGHT}
                                    onChange={e => {
                                        if (e.target.checked) {
                                            dispatch(changeTopbarTheme(e.target.value));
                                        }
                                    }}
                                />
                                <label className="form-check-label p-0 avatar-md w-100" htmlFor="topbar-color-light">
                                                <span className="d-flex gap-1 h-100">
                                                    <span className="flex-shrink-0">
                                                        <span className="bg-light d-flex h-100 flex-column gap-1 p-1">
                                                            <span
                                                                className="d-block p-1 px-2 bg-primary-subtle rounded mb-2"></span>
                                                            <span
                                                                className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                            <span
                                                                className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                            <span
                                                                className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                        </span>
                                                    </span>
                                                    <span className="flex-grow-1">
                                                        <span className="d-flex h-100 flex-column">
                                                            <span className="bg-light d-block p-1"></span>
                                                            <span className="bg-light d-block p-1 mt-auto"></span>
                                                        </span>
                                                    </span>
                                                </span>
                                </label>
                            </div>
                            <h5 className="fs-13 text-center mt-2">Luz</h5>
                        </div>
                        <div className="col-4">
                            <div className="form-check card-radio">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="data-topbar"
                                    id="topbar-color-dark"
                                    value={topbarThemeTypes.DARK}
                                    checked={topbarThemeType === topbarThemeTypes.DARK}
                                    onChange={e => {
                                        if (e.target.checked) {
                                            dispatch(changeTopbarTheme(e.target.value));
                                        }
                                    }}
                                />
                                <label className="form-check-label p-0 avatar-md w-100" htmlFor="topbar-color-dark">
                                                <span className="d-flex gap-1 h-100">
                                                    <span className="flex-shrink-0">
                                                        <span className="bg-light d-flex h-100 flex-column gap-1 p-1">
                                                            <span
                                                                className="d-block p-1 px-2 bg-primary-subtle rounded mb-2"></span>
                                                            <span
                                                                className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                            <span
                                                                className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                            <span
                                                                className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                        </span>
                                                    </span>
                                                    <span className="flex-grow-1">
                                                        <span className="d-flex h-100 flex-column">
                                                            <span className="bg-primary d-block p-1"></span>
                                                            <span className="bg-light d-block p-1 mt-auto"></span>
                                                        </span>
                                                    </span>
                                                </span>
                                </label>
                            </div>
                            <h5 className="fs-13 text-center mt-2">Escuro</h5>
                        </div>
                    </div>

                    {(layoutType === "vertical" || (layoutType === "semibox" && sidebarVisibilitytype === "show")) && (
                        <React.Fragment>
                            <div id="sidebar-size">
                                <h6 className="mt-4 mb-0 fw-semibold text-uppercase">Sidebar Size</h6>
                                <p className="text-muted">Choose a size of Sidebar.</p>

                                <div className="row">
                                    <div className="col-4">
                                        <div className="form-check sidebar-setting card-radio">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="data-sidebar-size"
                                                id="sidebar-size-default"
                                                value={leftsidbarSizeTypes.DEFAULT}
                                                checked={leftsidbarSizeType === leftsidbarSizeTypes.DEFAULT}
                                                onChange={e => {
                                                    if (e.target.checked) {
                                                        dispatch(changeLeftsidebarSizeType(e.target.value));
                                                    }
                                                }}
                                            />
                                            <label className="form-check-label p-0 avatar-md w-100"
                                                   htmlFor="sidebar-size-default">
                                                            <span className="d-flex gap-1 h-100">
                                                                <span className="flex-shrink-0">
                                                                    <span
                                                                        className="bg-light d-flex h-100 flex-column gap-1 p-1">
                                                                        <span
                                                                            className="d-block p-1 px-2 bg-primary-subtle rounded mb-2"></span>
                                                                        <span
                                                                            className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                                        <span
                                                                            className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                                        <span
                                                                            className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                                    </span>
                                                                </span>
                                                                <span className="flex-grow-1">
                                                                    <span className="d-flex h-100 flex-column">
                                                                        <span className="bg-light d-block p-1"></span>
                                                                        <span
                                                                            className="bg-light d-block p-1 mt-auto"></span>
                                                                    </span>
                                                                </span>
                                                            </span>
                                            </label>
                                        </div>
                                        <h5 className="fs-13 text-center mt-2">Padrão</h5>
                                    </div>

                                    <div className="col-4">
                                        <div className="form-check sidebar-setting card-radio">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="data-sidebar-size"
                                                id="sidebar-size-compact"
                                                value={leftsidbarSizeTypes.COMPACT}
                                                checked={leftsidbarSizeType === leftsidbarSizeTypes.COMPACT}
                                                onChange={e => {
                                                    if (e.target.checked) {
                                                        dispatch(changeLeftsidebarSizeType(e.target.value));
                                                    }
                                                }}
                                            />
                                            <label className="form-check-label p-0 avatar-md w-100"
                                                   htmlFor="sidebar-size-compact">
                                                            <span className="d-flex gap-1 h-100">
                                                                <span className="flex-shrink-0">
                                                                    <span
                                                                        className="bg-light d-flex h-100 flex-column gap-1 p-1">
                                                                        <span
                                                                            className="d-block p-1 bg-primary-subtle rounded mb-2"></span>
                                                                        <span
                                                                            className="d-block p-1 pb-0 bg-primary-subtle"></span>
                                                                        <span
                                                                            className="d-block p-1 pb-0 bg-primary-subtle"></span>
                                                                        <span
                                                                            className="d-block p-1 pb-0 bg-primary-subtle"></span>
                                                                    </span>
                                                                </span>
                                                                <span className="flex-grow-1">
                                                                    <span className="d-flex h-100 flex-column">
                                                                        <span className="bg-light d-block p-1"></span>
                                                                        <span
                                                                            className="bg-light d-block p-1 mt-auto"></span>
                                                                    </span>
                                                                </span>
                                                            </span>
                                            </label>
                                        </div>
                                        <h5 className="fs-13 text-center mt-2">Compactar</h5>
                                    </div>


                                    <div className="col-4">
                                        <div className="form-check sidebar-setting card-radio">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="data-sidebar-size"
                                                id="sidebar-size-small-hover"
                                                value={leftsidbarSizeTypes.SMALLHOVER}
                                                checked={leftsidbarSizeType === leftsidbarSizeTypes.SMALLHOVER}
                                                onChange={e => {
                                                    if (e.target.checked) {
                                                        dispatch(changeLeftsidebarSizeType(e.target.value));
                                                    }
                                                }}

                                            />
                                            <label className="form-check-label p-0 avatar-md w-100"
                                                   htmlFor="sidebar-size-small-hover">
                                                            <span className="d-flex gap-1 h-100">
                                                                <span className="flex-shrink-0">
                                                                    <span
                                                                        className="bg-light d-flex h-100 flex-column gap-1">
                                                                        <span
                                                                            className="d-block p-1 bg-primary-subtle mb-2"></span>
                                                                        <span
                                                                            className="d-block p-1 pb-0 bg-primary-subtle"></span>
                                                                        <span
                                                                            className="d-block p-1 pb-0 bg-primary-subtle"></span>
                                                                        <span
                                                                            className="d-block p-1 pb-0 bg-primary-subtle"></span>
                                                                    </span>
                                                                </span>
                                                                <span className="flex-grow-1">
                                                                    <span className="d-flex h-100 flex-column">
                                                                        <span className="bg-light d-block p-1"></span>
                                                                        <span
                                                                            className="bg-light d-block p-1 mt-auto"></span>
                                                                    </span>
                                                                </span>
                                                            </span>
                                            </label>
                                        </div>
                                        <h5 className="fs-13 text-center mt-2">Visualização suspensa pequena</h5>
                                    </div>
                                </div>
                            </div>

                            <div id="sidebar-view">
                                <h6 className="mt-4 mb-0 fw-semibold text-uppercase">Visualização da barra lateral</h6>
                                <p className="text-muted">Escolha a visualização Padrão ou Barra Lateral Destacada.</p>

                                <div className="row">
                                    <div className="col-4">
                                        <div className="form-check sidebar-setting card-radio">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="data-layout-style"
                                                id="sidebar-view-default"
                                                value={leftSidebarViewTypes.DEFAULT}
                                                checked={leftSidebarViewType === leftSidebarViewTypes.DEFAULT}
                                                onChange={e => {
                                                    if (e.target.checked) {
                                                        dispatch(changeLeftsidebarViewType(e.target.value));
                                                    }
                                                }}

                                            />
                                            <label className="form-check-label p-0 avatar-md w-100"
                                                   htmlFor="sidebar-view-default">
                                                            <span className="d-flex gap-1 h-100">
                                                                <span className="flex-shrink-0">
                                                                    <span
                                                                        className="bg-light d-flex h-100 flex-column gap-1 p-1">
                                                                        <span
                                                                            className="d-block p-1 px-2 bg-primary-subtle rounded mb-2"></span>
                                                                        <span
                                                                            className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                                        <span
                                                                            className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                                        <span
                                                                            className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                                    </span>
                                                                </span>
                                                                <span className="flex-grow-1">
                                                                    <span className="d-flex h-100 flex-column">
                                                                        <span className="bg-light d-block p-1"></span>
                                                                        <span
                                                                            className="bg-light d-block p-1 mt-auto"></span>
                                                                    </span>
                                                                </span>
                                                            </span>
                                            </label>
                                        </div>
                                        <h5 className="fs-13 text-center mt-2">Padrão</h5>
                                    </div>
                                    <div className="col-4">
                                        <div className="form-check sidebar-setting card-radio">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="data-layout-style"
                                                id="sidebar-view-detached"
                                                value={leftSidebarViewTypes.DETACHED}
                                                checked={leftSidebarViewType === leftSidebarViewTypes.DETACHED}
                                                onChange={e => {
                                                    if (e.target.checked) {
                                                        dispatch(changeLeftsidebarViewType(e.target.value));
                                                    }
                                                }}
                                            />
                                            <label className="form-check-label p-0 avatar-md w-100"
                                                   htmlFor="sidebar-view-detached">
                                                            <span className="d-flex h-100 flex-column">
                                                                <span
                                                                    className="bg-light d-flex p-1 gap-1 align-items-center px-2">
                                                                    <span
                                                                        className="d-block p-1 bg-primary-subtle rounded me-1"></span>
                                                                    <span
                                                                        className="d-block p-1 pb-0 px-2 bg-primary-subtle ms-auto"></span>
                                                                    <span
                                                                        className="d-block p-1 pb-0 px-2 bg-primary-subtle"></span>
                                                                </span>
                                                                <span className="d-flex gap-1 h-100 p-1 px-2">
                                                                    <span className="flex-shrink-0">
                                                                        <span
                                                                            className="bg-light d-flex h-100 flex-column gap-1 p-1">
                                                                            <span
                                                                                className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                                            <span
                                                                                className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                                            <span
                                                                                className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                                        </span>
                                                                    </span>
                                                                </span>
                                                                <span
                                                                    className="bg-light d-block p-1 mt-auto px-2"></span>
                                                            </span>
                                            </label>
                                        </div>
                                        <h5 className="fs-13 text-center mt-2">Desanexada</h5>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    )}

                    {(layoutType === "vertical" || layoutType === "twocolumn" || (layoutType === "semibox" && sidebarVisibilitytype === "show")) && (
                        <React.Fragment>
                            <div id="sidebar-color">
                                <h6 className="mt-4 mb-0 fw-semibold text-uppercase">Sidebar Color</h6>
                                <p className="text-muted">Escolha a cor clara ou escura da barra lateral.</p>

                                <div className="row">
                                    <div className="col-4">
                                        <div className="form-check sidebar-setting card-radio">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="data-sidebar"
                                                id="sidebar-color-light"
                                                value={leftSidebarTypes.LIGHT}
                                                checked={leftSidebarType === leftSidebarTypes.LIGHT}
                                                onChange={e => {
                                                    setShow(false);
                                                    if (e.target.checked) {
                                                        dispatch(changeSidebarTheme(e.target.value));
                                                    }
                                                }}
                                            />
                                            <label className="form-check-label p-0 avatar-md w-100"
                                                   htmlFor="sidebar-color-light">
                                                            <span className="d-flex gap-1 h-100">
                                                                <span className="flex-shrink-0">
                                                                    <span
                                                                        className="bg-white border-end d-flex h-100 flex-column gap-1 p-1">
                                                                        <span
                                                                            className="d-block p-1 px-2 bg-primary-subtle rounded mb-2"></span>
                                                                        <span
                                                                            className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                                        <span
                                                                            className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                                        <span
                                                                            className="d-block p-1 px-2 pb-0 bg-primary-subtle"></span>
                                                                    </span>
                                                                </span>
                                                                <span className="flex-grow-1">
                                                                    <span className="d-flex h-100 flex-column">
                                                                        <span className="bg-light d-block p-1"></span>
                                                                        <span
                                                                            className="bg-light d-block p-1 mt-auto"></span>
                                                                    </span>
                                                                </span>
                                                            </span>
                                            </label>
                                        </div>
                                        <h5 className="fs-13 text-center mt-2">Luz</h5>
                                    </div>
                                    <div className="col-4">
                                        <div className="form-check sidebar-setting card-radio">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="data-sidebar"
                                                id="sidebar-color-dark"
                                                value={leftSidebarTypes.DARK}
                                                checked={leftSidebarType === leftSidebarTypes.DARK}
                                                onChange={e => {
                                                    setShow(false);
                                                    if (e.target.checked) {
                                                        dispatch(changeSidebarTheme(e.target.value));
                                                    }
                                                }}
                                            />
                                            <label className="form-check-label p-0 avatar-md w-100"
                                                   htmlFor="sidebar-color-dark">
                                                            <span className="d-flex gap-1 h-100">
                                                                <span className="flex-shrink-0">
                                                                    <span
                                                                        className="bg-primary d-flex h-100 flex-column gap-1 p-1">
                                                                        <span
                                                                            className="d-block p-1 px-2 bg-white bg-opacity-10 rounded mb-2"></span>
                                                                        <span
                                                                            className="d-block p-1 px-2 pb-0 bg-white bg-opacity-10"></span>
                                                                        <span
                                                                            className="d-block p-1 px-2 pb-0 bg-white bg-opacity-10"></span>
                                                                        <span
                                                                            className="d-block p-1 px-2 pb-0 bg-white bg-opacity-10"></span>
                                                                    </span>
                                                                </span>
                                                                <span className="flex-grow-1">
                                                                    <span className="d-flex h-100 flex-column">
                                                                        <span className="bg-light d-block p-1"></span>
                                                                        <span
                                                                            className="bg-light d-block p-1 mt-auto"></span>
                                                                    </span>
                                                                </span>
                                                            </span>
                                            </label>
                                        </div>
                                        <h5 className="fs-13 text-center mt-2">Escuro</h5>
                                    </div>
                                    <div className="col-4">
                                        <button type="button"
                                            className={classnames(
                                                "btn btn-link avatar-md w-100 p-0 overflow-hidden border ",
                                                {collapsed: !show, active: show === true}
                                            )}
                                            type="button"
                                            data-bs-target="#collapseBgGradient"
                                            data-bs-toggle="collapse"
                                            aria-controls="collapseBgGradient"
                                            // checked={leftSidebarType === leftSidebarTypes.GRAD}
                                            onClick={tog_show}
                                        >
                                                        <span className="d-flex gap-1 h-100">
                                                            <span className="flex-shrink-0">
                                                                <span
                                                                    className="bg-vertical-gradient d-flex h-100 flex-column gap-1 p-1">
                                                                    <span
                                                                        className="d-block p-1 px-2 bg-white bg-opacity-10 rounded mb-2"></span>
                                                                    <span
                                                                        className="d-block p-1 px-2 pb-0 bg-white bg-opacity-10"></span>
                                                                    <span
                                                                        className="d-block p-1 px-2 pb-0 bg-white bg-opacity-10"></span>
                                                                    <span
                                                                        className="d-block p-1 px-2 pb-0 bg-white bg-opacity-10"></span>
                                                                </span>
                                                            </span>
                                                            <span className="flex-grow-1">
                                                                <span className="d-flex h-100 flex-column">
                                                                    <span className="bg-light d-block p-1"></span>
                                                                    <span
                                                                        className="bg-light d-block p-1 mt-auto"></span>
                                                                </span>
                                                            </span>
                                                        </span>
                                        </button>
                                        <h5 className="fs-13 text-center mt-2">Gradiente</h5>
                                    </div>
                                </div>
                                <Collapse
                                    isOpen={show}
                                    className="collapse"
                                    id="collapseBgGradient"
                                >
                                    <div className="d-flex gap-2 flex-wrap img-switch p-2 px-3 bg-light rounded">
                                        <div className="form-check sidebar-setting card-radio">
                                            <input className="form-check-input"
                                                   type="radio"
                                                   name="data-sidebar"
                                                   id="sidebar-color-gradient"
                                                   value={leftSidebarTypes.GRADIENT}
                                                   checked={leftSidebarType === leftSidebarTypes.GRADIENT}
                                                   onChange={e => {
                                                       if (e.target.checked) {
                                                           dispatch(changeSidebarTheme(e.target.value));
                                                       }
                                                   }}
                                            />
                                            <label className="form-check-label p-0 avatar-xs rounded-circle"
                                                   htmlFor="sidebar-color-gradient">
                                                <span
                                                    className="avatar-title rounded-circle bg-vertical-gradient"></span>
                                            </label>
                                        </div>
                                        <div className="form-check sidebar-setting card-radio">
                                            <input className="form-check-input"
                                                   type="radio"
                                                   name="data-sidebar"
                                                   id="sidebar-color-gradient-2"
                                                   value={leftSidebarTypes.GRADIENT_2}
                                                   checked={leftSidebarType === leftSidebarTypes.GRADIENT_2}
                                                   onChange={e => {
                                                       if (e.target.checked) {
                                                           dispatch(changeSidebarTheme(e.target.value));
                                                       }
                                                   }}
                                            />
                                            <label className="form-check-label p-0 avatar-xs rounded-circle"
                                                   htmlFor="sidebar-color-gradient-2">
                                                <span
                                                    className="avatar-title rounded-circle bg-vertical-gradient-2"></span>
                                            </label>
                                        </div>
                                        <div className="form-check sidebar-setting card-radio">
                                            <input className="form-check-input"
                                                   type="radio"
                                                   name="data-sidebar"
                                                   id="sidebar-color-gradient-3"
                                                   value={leftSidebarTypes.GRADIENT_3}
                                                   checked={leftSidebarType === leftSidebarTypes.GRADIENT_3}
                                                   onChange={e => {
                                                       if (e.target.checked) {
                                                           dispatch(changeSidebarTheme(e.target.value));
                                                       }
                                                   }}
                                            />
                                            <label className="form-check-label p-0 avatar-xs rounded-circle"
                                                   htmlFor="sidebar-color-gradient-3">
                                                <span
                                                    className="avatar-title rounded-circle bg-vertical-gradient-3"></span>
                                            </label>
                                        </div>
                                        <div className="form-check sidebar-setting card-radio">
                                            <input className="form-check-input"
                                                   type="radio"
                                                   name="data-sidebar"
                                                   id="sidebar-color-gradient-4"
                                                   value={leftSidebarTypes.GRADIENT_4}
                                                   checked={leftSidebarType === leftSidebarTypes.GRADIENT_4}
                                                   onChange={e => {
                                                       if (e.target.checked) {
                                                           dispatch(changeSidebarTheme(e.target.value));
                                                       }
                                                   }}
                                            />

                                            <label className="form-check-label p-0 avatar-xs rounded-circle"
                                                   htmlFor="sidebar-color-gradient-4">
                                                <span
                                                    className="avatar-title rounded-circle bg-vertical-gradient-4"></span>
                                            </label>
                                        </div>
                                    </div>
                                </Collapse>
                            </div>

                        </React.Fragment>
                    )}

                </div>
                <div className="mt-2 mb-2 d-flex justify-content-center col-12">
                    <button type="button"
                        className="btn btn-primary mt-3"
                        onClick={saveConfig}
                        disabled={loadingPage}
                    >
                        {loadingPage ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status"
                                      aria-hidden="true"></span>
                                Salvando...
                            </>
                        ) : (
                            <>
                                <i className="fa fa-save"></i> Salvar Configurações
                            </>
                        )}
                    </button>

                </div>

            </div>
        </div>
    );
};

export default ConfigLayoutPage;
